// removed by extract-text-webpack-plugin
module.exports = {"searchWrapper":"searchWrapper__Yr0dZ","searchHeader":"searchHeader__3J9Tz","opacityTransition":"opacityTransition__LN6sb","searchClose":"searchClose__2Ho_C","searchContainer":"searchContainer__2AYHe","openSearchFromMid":"openSearchFromMid__6Baq1","searchBoxWrapper":"searchBoxWrapper__7HU5x","noValue":"noValue__dWmB_","moveSearchToTop":"moveSearchToTop__19M79","searchResultWrapper":"searchResultWrapper__3OVOD","searchNoDataWrapper":"searchNoDataWrapper__1WuSI","searchItemWrapper":"searchItemWrapper__27w-2","searchItemTitle":"searchItemTitle__3kvcc","searchItemDescription":"searchItemDescription__2S_Am"};


//////////////////
// WEBPACK FOOTER
// ./components/header/components/search.scss
// module id = nbjb
// module chunks = 5